export default function Footer() {
  return (
    <div className="bg-bg-footer py-10 px-6 text-center relative overflow-hidden">
      {/* Subtle constellation in footer too */}
      <div className="absolute inset-0 constellation opacity-50" />

      <div className="relative z-[1] text-white/40 text-[13px] leading-[2]">
        <span className="text-gold-light/80 font-semibold tracking-[0.5px] inline-flex items-center gap-1.5">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" className="w-4 h-4">
            <defs><linearGradient id="lf" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stopColor="#F0D78C"/><stop offset="100%" stopColor="#D4A843"/></linearGradient></defs>
            <ellipse cx="32" cy="24" rx="8" ry="18" fill="url(#lf)" opacity=".95"/>
            <ellipse cx="32" cy="24" rx="8" ry="18" fill="url(#lf)" opacity=".85" transform="rotate(-30 32 38)"/>
            <ellipse cx="32" cy="24" rx="8" ry="18" fill="url(#lf)" opacity=".75" transform="rotate(-60 32 38)"/>
            <ellipse cx="32" cy="24" rx="8" ry="18" fill="url(#lf)" opacity=".85" transform="rotate(30 32 38)"/>
            <ellipse cx="32" cy="24" rx="8" ry="18" fill="url(#lf)" opacity=".75" transform="rotate(60 32 38)"/>
            <circle cx="32" cy="34" r="3.5" fill="#3B1F6E"/>
          </svg>
          spirit.charsoft.ai
        </span>
        <br />
        Powered by{' '}
        <strong className="text-white/60">Charsoft Consulting</strong>
        <br />
        <span className="text-white/25">Using AI and Technology to Elevate in Spirit</span>
        <br />
        <a href="/admin/leads" className="text-white/20 hover:text-white/40 transition-colors text-[11px]">Admin</a>
      </div>
    </div>
  )
}
